var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size md_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("FIELD.APPROVAL.DUP.TITLE")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("div", { staticClass: "grid_wrap" }, [
              _c("table", { staticClass: "scroll_table sm_grid noLine" }, [
                _c("thead", [
                  _c("tr", { staticClass: "text_center" }, [
                    _c("th", { attrs: { width: "25%" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.NAME")))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "15%" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CORPORATION")))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "15%" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.USER.TEAM")))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "15%" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.APPROVAL.TITLE")))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "15%" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.USER.OFFICE")))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { width: "15%" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.USER.MOBILE")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  {
                    staticClass: "text_center scroll",
                    staticStyle: { height: "300px" }
                  },
                  _vm._l(_vm.path, function(item) {
                    return _c(
                      "tr",
                      {
                        key: item.epId + "DuplicationApprovalPopup",
                        staticClass: "cur_pointer",
                        on: {
                          click: function($event) {
                            return _vm.rowClick(item.epId)
                          }
                        }
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "text_left ellipsis",
                            attrs: { width: "25%", title: item.enFullName }
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(item.enFullName) +
                                "\n                                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text_left ellipsis",
                            attrs: { width: "15%", title: item.enCompanyName }
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(item.enCompanyName) +
                                "\n                                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text_left ellipsis",
                            attrs: {
                              width: "15%",
                              title: item.enDepartmentName
                            }
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(item.enDepartmentName) +
                                "\n                                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text_left ellipsis",
                            attrs: { width: "15%", title: item.enTitleName }
                          },
                          [
                            _vm._v(
                              "\n                                        . "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text_left ellipsis",
                            attrs: { width: "15%", title: item.officeTelNumber }
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(item.officeTelNumber) +
                                "\n                                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text_left ellipsis",
                            attrs: { width: "15%", title: item.mobile }
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(item.mobile) +
                                "\n                                    "
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap topLine" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")) +
                        "\n                            "
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07a8cad0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a8cad0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/common/popup/DuplicationApprovalPopup.vue
// module id = LR4p
// module chunks = 0